import { styled } from 'common/src/designSystem/components/stitches';
import { MappableImportInput } from 'common/src/generated/types';
import { useTranslate } from 'common/src/util/dependencies/dependencies';
import * as React from 'react';
import { ColumnMapping } from './columnMapping';
import { ImportFieldCategory } from './types';

const Grid = styled('div', {
    display: 'grid',
    gridTemplateColumns: '[column] 1fr auto [field] 1fr',
    gap: '$4 $5',
    alignItems: 'center'
});

const ColumnHeader = styled('div', {
    color: '$gray800',
    gridColumn: 'column',
    fontWeight: '$medium'
});

const FieldHeader = styled('div', {
    color: '$gray800',
    gridColumn: 'field',
    fontWeight: '$medium'
});

interface IColumnMappingsProps {
    categories: ImportFieldCategory[];
    columns: string[];
    defaultFields: Record<string, string>;
    requiredFieldSlugs: string[];
    values: MappableImportInput['mappings'];
}

export const ColumnMappings = ({
    categories,
    columns,
    defaultFields,
    requiredFieldSlugs,
    values
}: IColumnMappingsProps) => {
    const translate = useTranslate();

    return (
        <Grid>
            <ColumnHeader>{translate('titres_de_vos_c_31388')}</ColumnHeader>
            <FieldHeader>{translate('champs_de_formu_64126')}</FieldHeader>
            {columns.map((name, index) => (
                <ColumnMapping
                    key={index}
                    categories={categories}
                    column={{ name, index }}
                    defaultFields={defaultFields}
                    requiredFieldSlugs={requiredFieldSlugs}
                    values={values}
                />
            ))}
        </Grid>
    );
};
